import React, { useState, useEffect, useRef } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const SearchableClientSelect = ({ clients, value, onChange, placeholder = "Select Client...", error = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const wrapperRef = useRef(null);

  const selectedClient = clients.find(c => c.id === value);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [wrapperRef]);

  const filteredClients = clients.filter(c => 
    (c.name || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (clientId) => {
    onChange(clientId);
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className="relative" ref={wrapperRef}>
      <div 
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full bg-slate-800 border rounded-xl px-4 py-3.5 text-white flex justify-between items-center cursor-pointer transition-all ${
          error ? 'border-red-500' : (isOpen ? 'border-teal-500 ring-2 ring-teal-500/20' : 'border-slate-700')
        }`}
      >
        <span className={selectedClient ? 'text-white font-medium' : 'text-slate-500'}>
          {selectedClient ? selectedClient.name : placeholder}
        </span>
        <SafeIcon icon={FiIcons.FiChevronDown} className={`text-slate-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </div>

      {isOpen && (
        <div className="absolute z-[60] mt-2 w-full bg-slate-900 border border-slate-700 rounded-xl shadow-2xl overflow-hidden animate-in fade-in slide-in-from-top-2">
          <div className="p-2 border-b border-slate-800">
            <div className="relative">
              <SafeIcon icon={FiIcons.FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm" />
              <input 
                autoFocus
                type="text"
                placeholder="Search..."
                className="w-full bg-slate-800 border border-slate-700 rounded-lg pl-9 pr-4 py-2 text-sm text-white focus:outline-none focus:border-teal-500"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="max-h-60 overflow-y-auto custom-scrollbar">
            {filteredClients.length > 0 ? (
              filteredClients.map(client => (
                <div 
                  key={client.id}
                  onClick={() => handleSelect(client.id)}
                  className={`px-4 py-3 text-sm cursor-pointer transition-colors flex items-center justify-between ${
                    client.id === value ? 'bg-teal-500/10 text-teal-400' : 'text-slate-300 hover:bg-slate-800'
                  }`}
                >
                  <span className="font-medium">{client.name}</span>
                  {client.id === value && <SafeIcon icon={FiIcons.FiCheck} className="text-teal-400" />}
                </div>
              ))
            ) : (
              <div className="px-4 py-6 text-center text-slate-500 text-sm italic">
                No clients found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchableClientSelect;